<div class="recommended-product-tile">
  <a [routerLink]="linkUrl" class="fx-col">
    <div class="image-container fx-row fx-row-h-center fx-row-v-center">
      <img [src]="getWebpImg(imageUrl)" [alt]="heading" />
    </div>
    <span class="swiper-slide-heading" [innerHTML]="heading | safe : 'html'"> </span>
  </a>
</div>
